module.exports = __webpack_public_path__ + "media/87_Long.01fac380.mp3";